import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { hidePartnerfriedhoefeNav } from 'src/app/config/ui-flags';
import { CremationService } from '../../../services/cremation.service';
import { CremationSection } from '../../../models/cremation.model';
import { CemeteryService } from '../../../services/cemetery.service';

declare function initCollapsible(): void;

@Component({
  selector: 'app-cremation',
  templateUrl: './cremation.component.html',
  styleUrls: ['./cremation.component.scss']
})
export class CremationComponent implements OnInit {
  sections: CremationSection[] = [];
  selectedSectionId: string | null = null;
  readonly hidePartnerfriedhoefeNav = hidePartnerfriedhoefeNav;

  constructor(
    private router: Router,
    private cremationService: CremationService,
    private cemeteryService: CemeteryService
  ) {}

  ngOnInit(): void {
    this.sections = this.cremationService.getSections();
    this.cremationService.selectedSection$.subscribe(id => {
      this.selectedSectionId = id;
    });
  }

  selectSection(id: string): void {
    this.cremationService.setSelectedSection(id === this.selectedSectionId ? null : id);
  }

  isSelected(id: string): boolean {
    return this.selectedSectionId === id;
  }

  navigateToCemetery(section: CremationSection): void {
    if (section.cemeteryLink) {
      // Setze den ausgewählten Friedhof im CemeteryService
      this.cemeteryService.setSelectedCemetery(section.cemeteryLink.cemeteryId);
      // Navigiere zur Partnerfriedhöfe-Seite
      this.router.navigate(['dash', 'partnered']);
    }
  }

  ngAfterViewInit() {
    initCollapsible();
  }

  navigateToGY(link: string): void {
    this.router.navigate(['dash', 'partnered', link]);
  }
}
